import styled from 'styled-components';

/**
 * A muted one-line explanation with a leading info glyph — what happens next,
 * or why something works the way it does. Helper text, so sentence case and
 * `--text-muted`; never a warning (that is a toast or a field error).
 */
export const DialogNote = styled.p`
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  margin: 0;
  font-family: var(--font-primary);
  font-size: var(--text-xs);
  line-height: var(--leading-text-xs);
  color: var(--text-muted);

  svg {
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    margin-top: 1px;
  }
`;
